import React, { Fragment, useContext, useState, useEffect } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AccountDetailsTwoTone, ChevronRightTwoTone } from 'common/icons';
import styles from './drawer.module.css';
  
import { signOut } from 'firebase/auth';
import { auth } from '../../../firebase/config';
import { Routes } from 'common/enums';
import { appContext } from 'common/contexts/appContext';
import { openCashierClose } from '../cashierCloseSimple/cashierCloseManager';
import { openCashRegister, addCash, withdrawCash } from '../cashRegister/cashRegisterManager';

type DrawerProps = {
  onClose: () => void;
};

const Drawer: React.FC<DrawerProps> = ({ onClose }) => {
  const [redirect, setRedirect] = useState(false);
  const [redirectToItems, setRedirectToItems] = useState(false);
  const [t] = useTranslation();
  const history = useHistory();

  const context = useContext(appContext);
  const isAdmin = context?.state?.isAdmin || false;
  const isEditor = context?.state?.isEditor || false;
  const currentUserId = auth.currentUser?.uid;
  const userRole = context?.state?.users?.find(u => u.id === currentUserId)?.role || '';
  const canAccessCashRegister = isAdmin || userRole === 'cashier';

  useEffect(() => {

  }, []);

  const handleOnClickOnClose = () => onClose();
  const handleOnClickOnBackdrop = () => onClose();
  const handleOnClickOnAdmin = () => setRedirect(true);
  const handleOnClickOnItems = () => setRedirectToItems(true);
  const handleOnClickOnCashierClose = () => {
    onClose();
    openCashierClose();
  };
  const handleOnClickOnOpenRegister = () => {
    onClose();
    openCashRegister();
  };
  const handleOnClickOnAddCash = () => {
    onClose();
    addCash();
  };
  const handleOnClickOnWithdrawCash = () => {
    onClose();
    withdrawCash();
  };
  
  if (redirect) return <Redirect to={'/admin'} />;
  if (redirectToItems) return <Redirect to={Routes.AdminItemList} />;
  
  const handleLogout = async () => {
    try {
      await signOut(auth);
      history.replace(Routes.SignIn);
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  };
  
  return (
    <Fragment>
      <div className={styles.root}>
        <div className={styles.head}>
          <button className={styles.menuBtn} onClick={handleOnClickOnClose}>
            <ChevronRightTwoTone />
          </button>
        </div>
        <div className={styles.body}>
          {isAdmin && (
            <div className={styles.menuItem} onClick={handleOnClickOnAdmin}>
              <div className={styles.menuIcon}>
                <AccountDetailsTwoTone />
              </div>
              <div className={styles.menuLabel}>{t('admin.menuLabel')}</div>
            </div>
          )}

          {isEditor && !isAdmin && (
            <div className={styles.menuItem} onClick={handleOnClickOnItems}>
              <div className={styles.menuIcon}>
                <AccountDetailsTwoTone />
              </div>
              <div className={styles.menuLabel}>{t('admin.menu.myProductsLabel', 'Mis Productos')}</div>
            </div>
          )}
          
          {canAccessCashRegister && (
            <div className={styles.menuSection}>
              <div className={styles.menuSectionTitle}>{t('terminal.cashRegister.title')}</div>
              
              <div className={styles.menuItem} onClick={handleOnClickOnOpenRegister}>
                <div className={styles.menuIcon}></div>
                <div className={styles.menuLabel}>{t('terminal.cashRegister.openRegister')}</div>
              </div>
              
              <div className={styles.menuItem} onClick={handleOnClickOnAddCash}>
                <div className={styles.menuIcon}></div>
                <div className={styles.menuLabel}>{t('terminal.cashRegister.addCash')}</div>
              </div>
              
              <div className={styles.menuItem} onClick={handleOnClickOnWithdrawCash}>
                <div className={styles.menuIcon}></div>
                <div className={styles.menuLabel}>{t('terminal.cashRegister.withdrawCash')}</div>
              </div>
              
              <div className={styles.menuItem} onClick={handleOnClickOnCashierClose}>
                <div className={styles.menuIcon}></div>
                <div className={styles.menuLabel}>{t('terminal.cashierClose.menuLabel')}</div>
              </div>
            </div>
          )}
          
          <div className={styles.menuItem} onClick={handleLogout}>
            <div className={styles.menuIcon}>
              
            </div>
            <div className={styles.menuLabel}>{t('common.logout')}</div>
          </div>
        </div>
      </div>
      <div className={styles.backdrop} onClick={handleOnClickOnBackdrop} />
    </Fragment>
  );
};

export default Drawer;
